/**
 * Static job postings data
 * Used for initial launch before the recruitment API is deployed
 * TODO: Replace with API calls when backend recruitment module is live
 */
import type { JobPosting } from '@/types'

export const STATIC_JOBS: Record<string, JobPosting> = {
  'senior-fsd-digital-signature-2026': {
    jobPostingId: 'senior-fsd-digital-signature-2026',
    tenantId: 'devsquad',
    title: 'Desenvolvedor(a) Full Stack Sênior — Plataforma de Assinatura Digital',
    department: 'Engenharia',
    location: '100% Remoto',
    workMode: 'remote',
    employmentType: 'contract',
    seniority: 'senior',
    description:
      'Somos a DevSquad — uma empresa 100% remota, ágil, formada por profissionais de tecnologia talentosos e comprometidos em entregar soluções inteligentes para problemas complexos de negócio.\n\nEstamos crescendo! Buscamos um(a) Desenvolvedor(a) Full Stack Sênior para trabalhar em uma plataforma de assinatura eletrônica e digital. Você vai construir e evoluir um produto SaaS em produção usado por milhares de usuários diariamente, enfrentando desafios em workflows de documentos, assinatura criptográfica, arquitetura multi-tenant e infraestrutura serverless na AWS.\n\nInteressado(a)? Candidate-se e vamos conversar!',
    responsibilities: [
      'Desenvolver novas funcionalidades e aplicações usando React, Tailwind CSS, Node.js e Serverless Framework',
      'Construir e manter infraestrutura serverless na AWS: Lambda, DynamoDB, SQS, SES, IAM',
      'Projetar e implementar serviços backend escaláveis com arquitetura multi-tenant',
      'Corrigir bugs e resolver incidentes em produção',
      'Eliminar dívida técnica e melhorar a qualidade do código em todo o stack',
      'Participar da criação de frameworks internos e ferramentas para desenvolvedores',
      'Colaborar com QA, UX e produto na entrega de funcionalidades',
      'Escrever testes e manter uma mentalidade de qualidade em todas as entregas',
    ],
    requirementsTechnical: [
      'Mínimo de 5 anos de experiência como Engenheiro(a) de Software',
      'Mínimo de 5 anos de experiência com Node.js',
      'Mínimo de 3 anos de experiência com React',
      'Mínimo de 3 anos de experiência com AWS (Lambda, DynamoDB, SQS, SES, IAM)',
      'Mínimo de 2 anos de experiência com Serverless Framework',
      'Experiência sólida com Tailwind CSS e ferramentas modernas de frontend',
      'Experiência comprovada com Git e Docker',
      'Mentalidade de testes — unitários, integração e E2E',
      'Experiência com Java é um diferencial',
      'Experiência com Claude Code / desenvolvimento assistido por IA é um diferencial',
    ],
    requirementsBehavioral: [
      'Boa comunicação — clara, objetiva, assíncrona',
      'Autodidata — aprendizado contínuo de novas tecnologias',
      'Autogerenciável — dono(a) da sua agenda e das suas entregas',
      'Paixão por eliminar dívida técnica',
      'Praticante de DevOps e Agile',
    ],
    benefits: [
      'Flexibilidade total: trabalhe de qualquer lugar, a qualquer hora',
      'Time incrível com uma cultura excepcional',
      'Processos Lean e Ágeis, focados em produtividade e bem-estar do desenvolvedor',
      'Cultura DevOps de verdade — processos e ferramentas',
      'Autonomia e empoderamento: participe das grandes decisões',
      'Ambiente de melhoria contínua',
      'Remuneração competitiva em R$ por hora',
    ],
    status: 'active',
    visibility: 'public',
    createdAt: '2026-02-27T00:00:00.000Z',
    updatedAt: '2026-02-27T00:00:00.000Z',
  },
}

/**
 * Default job ID shown when accessing the root URL
 */
export const DEFAULT_JOB_ID = 'senior-fsd-digital-signature-2026'

/**
 * Contact email for applications
 * TODO: Replace with actual recruitment email before sharing
 */
export const APPLY_EMAIL = 'recrutamento@devsquad.com.br'

/**
 * Application email subject template
 */
export function getApplySubject(jobTitle: string): string {
  return `DevSquad Application — ${jobTitle}`
}

/**
 * Application email body template
 */
export function getApplyBody(jobTitle: string): string {
  return `Hi DevSquad team,

I'm interested in the "${jobTitle}" position.

Please find my details below:

Full Name:
LinkedIn:
GitHub/Portfolio:
Years of Experience:
Brief intro:

I've attached my CV to this email.

Best regards,`
}
